module.exports = __webpack_public_path__ + "static/media/playp16.d3f22f92.ico";